import { StylesConfig } from "react-select";
import { IOption } from "../../../../../../components/inputs/select-dropdown/select-dropdown";

const circleStyles = (color = '') => {
    if (!color) return;
    return {
        alignItems: 'center',
        display: 'flex',

        ':before': {
            backgroundColor: color,
            borderRadius: 22,
            content: '" "',
            marginRight: 12,
            height: 22,
            width: 22,
        },
    }
};

export const colourStyles: StylesConfig<IOption> = {
    control: (styles) => ({ ...styles, backgroundColor: 'var(--color-neutral-1-white)' }),
    option: (styles, { data, isDisabled, isSelected }) => {
        return {
            ...styles,
            ...circleStyles(String(data.value)),
            backgroundColor: isDisabled
                ? undefined
                : isSelected
                    ? String(data.value)
                    : undefined,
            color: isDisabled
                ? 'var(--color-neutral-3)'
                : isSelected
                    ? 'white'
                    : 'black',
            cursor: isDisabled ? 'not-allowed' : 'default',

            ':active': {
                ...styles[':active'],
                backgroundColor: !isDisabled
                    ? isSelected
                        ? String(data.value)
                        : undefined : undefined
            },
        };
    },
    input: (styles) => ({ ...styles, caretColor: 'transparent', ...circleStyles() }),
    singleValue: (styles, { data }) => ({ ...styles, ...circleStyles(String(data.value)) }),
};
